import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

export const getEventResponsibilities = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/event-responsibility`);
    return response.data;
  } catch (error) {
    console.error('Error fetching event responsibilities:', error.response?.data || error);
    throw error;
  }
};

export const getEventResponsibilityById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/event-responsibility/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching event responsibility:', error.response?.data || error);
    throw error;
  }
};

export const createEventResponsibility = async (data) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/event-responsibility`, data);
    return response.data;
  } catch (error) {
    console.error('Error creating event responsibility:', error.response?.data || error);
    throw error;
  }
};

export const updateEventResponsibility = async (id, data) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/event-responsibility/${id}`, data);
    return response.data;
  } catch (error) {
    console.error('Error updating event responsibility:', error.response?.data || error);
    throw error;
  }
};

export const deleteEventResponsibility = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/event-responsibility/${id}`);
    return response.data;
  } catch (error) {
    console.error('Error deleting event responsibility:', error.response?.data || error);
    throw error;
  }
};
